import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Company',
     label: 'Company',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'name',
     field: FIELDS.NAME,
     title: 'Address Name',
     label: 'Address Name',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'addressTypeName',
     field: FIELDS.ADDRESS_TYPE_NAME,
     title: 'Type',
     label: 'Type',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'fullAddress',
     field: FIELDS.FULL_ADDRESS,
     title: 'Full Address',
     label: 'Full Address',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'address1',
     field: FIELDS.ADDRESS1,
     title: 'Address 1',
     label: 'Address 1',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'address2',
     field: FIELDS.ADDRESS2,
     title: 'Address 2',
     label: 'Address 2',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'address3',
     field: FIELDS.ADDRESS3,
     title: 'Address 3',
     label: 'Address 3',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'city',
     field: FIELDS.CITY,
     title: 'City',
     label: 'City',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'state',
     field: FIELDS.STATE,
     title: 'State',
     label: 'State',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'zipCode',
     field: FIELDS.ZIP_CODE,
     title: 'Zip Code',
     label: 'Zip Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'countryCode',
     field: FIELDS.COUNTRY_CODE,
     title: 'Country Code',
     label: 'Country Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'country',
     field: FIELDS.COUNTRY,
     title: 'Country',
     label: 'Country',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'addressVat',
     field: FIELDS.ADDRESS_VAT,
     title: 'Address VAT',
     label: 'Address VAT',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'contactName',
     field: FIELDS.CONTACT_NAME,
     title: 'Contact',
     label: 'Contact',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'phone',
     field: FIELDS.PHONE,
     title: 'Phone',
     label: 'Phone',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'fax',
     field: FIELDS.FAX,
     title: 'Fax',
     label: 'Fax',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'taxId',
     field: FIELDS.TAX_ID,
     title: 'Tax Id',
     label: 'Tax Id',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'vatNumber',
     field: FIELDS.VATNUMBER,
     title: 'VAT Number',
     label: 'VAT Number',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isDefault',
     field: FIELDS.IS_DEFAULT,
     title: 'Is Default',
     label: 'Is Default',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
